import {takeEvery} from 'redux-saga';
import {toastr} from 'react-redux-toastr';
import {$post, $put, $delete} from '../_utils/restSaga';

import {
  MODIFY_SKIRESORT,
  ADD_SKIRESORT,
  DELETE_SKIRESORT,
  CHANGE_DATES,
  modifySkiresortSuccess,
  modifySkiresortFailure,
  addSkiresortSuccess,
  addSkiresortFailure,
  deleteSkiresortSuccess,
  deleteSkiresortFailure,
  changeDatesSuccess,
  changeDatesFailure
} from './actions';

function* showMessageOnAddSuccess() {
  toastr.success('La nouvelle station a bien été ajoutée, veuillez rafraichir la page pour pouvoir y accéder');
}

function* showDateMessageOnAddSuccess() {
  toastr.success('Les dates ont bien été modifiées, veuillez rafraichir la page pour voir les changements');
}

export default function*() {
  yield [
    takeEvery(MODIFY_SKIRESORT.do, $put('/api/skiresort/#{id}',
      modifySkiresortSuccess, modifySkiresortFailure)),
    takeEvery(CHANGE_DATES.do, $put('/api/skiresorts/dates/change',
      changeDatesSuccess, changeDatesFailure)),
    takeEvery(ADD_SKIRESORT.do,$post('/api/skiresort',
       addSkiresortSuccess, addSkiresortFailure)),
    takeEvery(DELETE_SKIRESORT.do, $delete('/api/skiresort/#{id}',
      deleteSkiresortSuccess, deleteSkiresortFailure)),
    takeEvery(ADD_SKIRESORT.success, showMessageOnAddSuccess),
    takeEvery(CHANGE_DATES.success, showDateMessageOnAddSuccess)
  ];
}



// WEBPACK FOOTER //
// ./src/redux/skiresorts/saga.js